module.exports = __webpack_public_path__ + "static/media/Data Asset Page Icons-04.235e5cee.svg";